export default "__VITE_ASSET__CcTA5Qpo__"